<template>
  <div
      class="my-3 col-lg-4 col-md-4 col-12"
  >
    <label class="mx-2 my-1 text-nowrap" :for="field.id + '-field'">
      {{field.fa_name || field.name }}
      <span v-if="field.status === fieldStatus.REQUIRED" class="text-danger">*</span>
    </label>
    <div class="flex-column justify-content-center align-items-center">
      <select
          class="form-control"
          :disabled="!customer_style"
          :class="{'form-control light-input': customer_style}"
          :id="field.id + '-field'"
          @change="validateField"
          v-model="value"
      >
        <option :value="null">{{'لطفا انتخاب کنید'}}</option>
        <option
            v-for="option in field.details.find(i => i.type === 'options').data"
            :key="option"
            :value="option"
        >
          {{option}}
        </option>
      </select>
      <small v-show="!value && field.status === this.fieldStatus.REQUIRED" class="text-danger text-tiny">این فیلد اجباری می باشد.</small>
    </div>
  </div>
</template>

<script>
import { fieldOptionsConstants } from '@/constants/CustomerFormatFieldOptions';

export default {
  name: 'SelectInput',
  props: {
    field: {
      type: Object,
      required: true
    },
    customer_style: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      value: null
    }
  },
  watch: {
    value: function(newVal) {
      if (this.field.status === this.fieldStatus.REQUIRED && !newVal) {
        this.field.error = true
      }
      this.field.value = newVal
    }
  },
  computed: {
    fieldStatus(){
      return fieldOptionsConstants
    },
  },
  methods: {
    initialDefaultValue() {
      const defaultOption = this.field.details.find(item => item.type === 'default_value');
      this.field.value = defaultOption ? defaultOption.data : null
      this.value = this.field.value
    },
    validateField() {
      if (this.field.status === this.fieldStatus.REQUIRED && this.field.value === null) {
        this.field.error = true
        this.$emit('validate', { fieldId: this.field.id, isValid: false })
      } else {
        this.field.error = false;
        this.$emit('validate', { fieldId: this.field.id, isValid: true });
      }
    }
  },
  created() {
    this.initialDefaultValue()
  }
};
</script>

<style scoped>
.light-input, .light-input::placeholder {
  background-color: ghostwhite !important;
  color: gray !important;
  border-color: #8c8a8a !important;
}
</style>